import { getDefaultHeaders } from "./utils";

export async function getImageProxy(backgroundImageUrl) {
  console.log("background image in slicer", backgroundImageUrl);
  try {
    const headers = await getDefaultHeaders(true, true);
    const requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ url: backgroundImageUrl }),
    };

    const url = `/api/image-proxy/`;

    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error || `HTTP error ${response.status}`);
    }

    return response;
  } catch (err) {
    console.error("Error fetching character information:", err);
    throw err;
  }
}


export const POSThttpMethod = async (formData, apiEndpoint, returnJson = true) => {
  let headers = await getDefaultHeaders(false, true);
  try {
    const response = await fetch(apiEndpoint, {
      headers: headers,
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({})); // Avoid crashing if error response is not JSON
      throw new Error(errorData.detail || `Request to ${apiEndpoint} failed with status ${response.status}`);
    }

    return returnJson ? await response.json() : response;
  } catch (error) {
    console.error(`Error in POSThttpMethod for endpoint ${apiEndpoint}:`, error);
    return { success: false, error: error.message };
  }
};